// In production the frontend is served by the same host as the API (nginx proxy).
// In dev the craco devServer proxies /api to localhost:10000, so relative URLs work too.
const API_BASE = process.env.REACT_APP_API_BASE || '';

export default API_BASE;
